import Vue from 'vue'

// Capa de API de la integración con Copec. Sigue el mismo patrón que el resto
// de módulos: las acciones llaman directamente a axios y devuelven el error en
// vez de propagarlo.
export const state = {
  copecStatuses: {},
  copecConfiguredChecklistId: null,
  copecConfig: null,
  copecProtectedQuestions: []
}

export const getters = {
  copecStatuses: (state) => state.copecStatuses,
  copecConfiguredChecklistId: (state) => state.copecConfiguredChecklistId,
  copecConfig: (state) => state.copecConfig,
  copecProtectedQuestions: (state) => state.copecProtectedQuestions,
  copecProtectedQuestionIds: (state) => state.copecProtectedQuestions.map((q) => q.id)
}

export const mutations = {
  SET_COPEC_STATUSES(state, payload) {
    state.copecStatuses = payload.items || {}
    state.copecConfiguredChecklistId = payload.configured_checklist_id || null
  },
  SET_COPEC_STATUS(state, { placeChecklistId, status }) {
    Vue.set(state.copecStatuses, String(placeChecklistId), status)
  },
  SET_COPEC_CONFIG(state, payload) {
    state.copecConfig = payload
  },
  SET_COPEC_PROTECTED_QUESTIONS(state, payload) {
    state.copecProtectedQuestions = payload || []
  }
}

export const actions = {
  async getCopecStatusByPlace({ commit }, payload) {
    try {
      const response = (await Vue.axios.get(`/integrations/copec/status?place_id=${payload.place_id}`)).data
      commit('SET_COPEC_STATUSES', response)
      return response
    } catch (error) {
      // Que la integración no responda no debe romper la pantalla de plantillas.
      commit('SET_COPEC_STATUSES', {})
      return error
    }
  },

  async getCopecStatus({ commit }, payload) {
    try {
      const query = payload.history ? '?history=true&limit=50' : ''
      const response = (
        await Vue.axios.get(
          `/integrations/copec/place-checklist/${payload.place_checklist_id}/status${query}`
        )
      ).data
      commit('SET_COPEC_STATUS', {
        placeChecklistId: payload.place_checklist_id,
        status: {
          status: response.status,
          status_label: response.status_label,
          attempts: response.attempts,
          last_sent_at: response.last_sent_at,
          errors: response.errors
        }
      })
      return response
    } catch (error) {
      return error
    }
  },

  async sendCopecSync(_, payload) {
    const query = payload.force ? '?force=true' : ''
    try {
      const response = await Vue.axios.post(
        `/integrations/copec/place-checklist/${payload.place_checklist_id}/send${query}`
      )
      return { status: response.status, data: response.data }
    } catch (error) {
      // El backend usa el código HTTP para distinguir «faltan datos» de
      // «Copec falló», así que hay que conservarlo.
      const response = error.response || {}
      return { status: response.status || 0, data: response.data || {} }
    }
  },

  async getCopecConfig({ commit }) {
    try {
      const response = (await Vue.axios.get('/integrations/copec/config')).data
      commit('SET_COPEC_CONFIG', response)
      return response
    } catch (error) {
      return error
    }
  },

  async updateCopecConfig({ commit }, payload) {
    try {
      const response = (await Vue.axios.put('/integrations/copec/config', payload)).data
      commit('SET_COPEC_CONFIG', response)
      return { ok: true, data: response }
    } catch (error) {
      const response = error.response || {}
      return { ok: false, data: response.data || {} }
    }
  },

  async getCopecProtectedQuestions({ commit }, payload = {}) {
    try {
      const query = payload.checklist_id ? `?checklist_id=${payload.checklist_id}` : ''
      const response = (await Vue.axios.get(`/integrations/copec/protected-questions${query}`)).data
      commit('SET_COPEC_PROTECTED_QUESTIONS', response.questions)
      return response
    } catch (error) {
      commit('SET_COPEC_PROTECTED_QUESTIONS', [])
      return error
    }
  },

  async saveCopecBrandMapping(_, payload) {
    try {
      const response = payload.id
        ? await Vue.axios.put(`/integrations/copec/brand-mappings/${payload.id}/`, payload)
        : await Vue.axios.post('/integrations/copec/brand-mappings/', payload)
      return { ok: true, data: response.data }
    } catch (error) {
      const response = error.response || {}
      return { ok: false, data: response.data || {} }
    }
  },

  async deleteCopecBrandMapping(_, id) {
    try {
      await Vue.axios.delete(`/integrations/copec/brand-mappings/${id}/`)
      return { ok: true }
    } catch (error) {
      return { ok: false }
    }
  }
}
